var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-ctn",style:(_vm.style),attrs:{"id":`wtpie_${_vm.id}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }